<template>
  <div>
    <v-form ref="marginForm" lazy-validation>
      <v-data-table
        :headers="headers"
        :items="margins"
        :loading="loading"
        loader-height="2"
        :items-per-page="-1"
        hide-default-footer
      >
        <template v-slot:no-data>
          <EmptyState icon="mdi-inbox-outline" :title="'emptyGenericTitle'|localize" :subtitle="'emptyGenericSubtitle'|localize"/>
        </template>
        <template v-slot:item.category="{ item }">
          <v-text-field
            background-color="white"
            v-model="item.category"
            dense
            hide-details
            outlined
            maxlength="3"
            :rules="[existingCategoryRule(), validationRules.required]"
          />
        </template>
        <template v-slot:item.air="{ item }">
          <v-text-field
            :background-color="item.air || (item.air === 0) ? 'serenade' : 'white'"
            v-model.trim.number="item.air"
            @blur="item.air = item.air !== '' ? item.air : null"
            dense
            hide-details
            outlined
            :rules="[validationRules.integer]"
          />
        </template>
        <template v-slot:item.sea="{ item }">
          <v-text-field
            :background-color="item.sea || (item.sea === 0) ? 'serenade' : 'white'"
            v-model.trim.number="item.sea"
            @blur="item.sea = item.sea !== '' ? item.sea : null"
            dense
            hide-details
            outlined
            :rules="[validationRules.integer]"
          />
        </template>
        <template v-slot:item.rail="{ item }">
          <v-text-field
            :background-color="item.rail || (item.rail === 0) ? 'serenade' : 'white'"
            v-model.trim.number="item.rail"
            @blur="item.rail = item.rail !== '' ? item.rail : null"
            dense
            hide-details
            outlined
            :rules="[validationRules.integer]"
          />
        </template>
        <template v-slot:item.road="{ item }">
          <v-text-field
            :background-color="item.road || (item.road === 0)? 'serenade' : 'white'"
            v-model.trim.number="item.road"
            @blur="item.road = item.road !== '' ? item.road : null"
            dense
            hide-details
            outlined
            :rules="[validationRules.integer]"
          />
        </template>
      </v-data-table>
    </v-form>
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            rounded
            depressed
            color="primary"
            :loading="saveLoading"
            :disabled="saveLoading || loading"
            @click="saveMargin"
          > {{ 'save'|localize }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import validationRules from '../helpers/validationRules';
  import localize from '@/filters/localize';
  import api from '@/api/api';
  import methods from '@/helpers/methods';
  import SimpleDialog from '@/components/common/SimpleDialog';
  import EmptyState from '@/components/common/EmptyState';

  export default {
    name: "SecondLevel",
    props: ['loading'],
    components: {SimpleDialog, EmptyState},

    data() {
      return {
        validationRules: validationRules,
        margins: [],
        saveLoading: false,
      };
    },

    mounted() {
      this.getMargins();
    },

    computed: {
      headers() {
        return [
          {text: localize('category'), value: 'category', width: 100, sortable: false},
          {text: localize('air') + ', %', value: 'air', sortable: false},
          {text: localize('sea') + ', %', value: 'sea', sortable: false},
          {text: localize('rail') + ', %', value: 'rail', sortable: false},
          {text: localize('road') + ', %', value: 'road', sortable: false},
        ];
      },
    },

    methods: {
      setMarginsData(requestsData) {
        this.margins = requestsData.data;
        this.margins.sort((a,b) => (a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0))
      },
      async getMargins() {
        try {
          this.$emit('updateLoading', true);
          let marginsData = await api.getSecondLevelMargins();
          this.setMarginsData(marginsData);
          this.$emit('updateLoading', false);
        } catch (e) {
          this.$emit('updateLoading', false);
        }
      },
      queryData() {
        let queryData = {};
        let item = {};
        this.margins.forEach(element => {
          item = {
            "air": element.air,
            "sea": element.sea,
            "rail": element.rail,
            "road": element.road
          };
          element.category = element.category.toUpperCase();
          queryData[element.category] = item
        })
        return {'margin': JSON.stringify(queryData)};
      },
      async saveMargin() {
        if (this.$refs.marginForm.validate()) {
          try {
            this.saveLoading = true;
            await api.saveSecondLevelMargin(this.queryData());
            let marginsData = await api.getSecondLevelMargins();
            this.setMarginsData(marginsData);
            this.saveLoading = false;
            methods.showGlobalSnackbar('success', localize('done'));
          } catch (e) {
            this.saveLoading = false;
            methods.showGlobalSnackbar('error', methods.getErrors(e.response));
          }
        }
      },
      existingCategoryRule() {
        return v => !v || this.margins.filter(x => x.category) === null || this.margins.filter(x => x.category.toUpperCase() === v.toUpperCase()).length <= 1 || '';
      }
    },
  };
</script>
